<template>
  <div class="page-content">
    <div class="page-title">
      <h5>我的论文</h5>
    </div>
    <!-- <div class="xuanke_box panel"> -->
    <div class="panel">
      <div class="">
        <!-- <template v-if="config.tips">
          <div style="color: red">
            重要提示：
            <span v-html="config.tips"></span>
          </div>
        </template> -->
        <template
          v-if="
            // config.tips &&
            config.notice &&
            (!config.noticeEndDate || $utils.toTime(config.noticeEndDate) > nowDate)
          "
        >
          <br />
        </template>
        <template
          v-if="
            config.notice &&
            (!config.noticeEndDate || $utils.toTime(config.noticeEndDate) > nowDate)
          "
        >
          <div>
            <span class="red">考生论文须知：</span>
            <div
              id="t_notice_content"
              v-html="config.notice"
              class="t_notice_content"
            ></div>
          </div>
          <input type="hidden" id="boo" value="true" />
        </template>
        <table width="100%" cellpadding="5" border="0" class="tm_table_form">
          <tbody>
            <template v-if="configs">
              <tr>
                <th style="width: 200px">批次 :</th>
                <td>
                  <div class="d-flex d-flex-middle d-flex-between">
                    <el-select
                      size="mini"
                      v-model="defaultThesisBatchId"
                      @change="getInfo"
                    >
                      <el-option
                        v-for="item in configs"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                    <!-- <a :href="thesisTempleteUrl" target="_blank" v-if="thesisTempleteUrl">查看论文资料</a> -->
                  </div>
                </td>
              </tr>
            </template>
            <template v-if="thesis == null && bm != null && db == null">
              <tr>
                <th>状态 :</th>
                <td>
                  待上传<span style="margin-left: 10px"
                    >[时间段：
                    {{
                      config.guidanceStartTime | dateFormat("yyyy-MM-dd HH:mm")
                    }}
                    至
                    {{ config.guidanceEndTime | dateFormat("yyyy-MM-dd HH:mm") }}
                    ]
                  </span>
                </td>
              </tr>
              <tr>
                <th>主考学校 :</th>
                <td>{{ `${bm.schoolCode}-${bm.schoolName||bm.schName}` }}</td>
              </tr>
              <!-- <tr>
                <th>学院 :</th>
                <td>{{ bm.college_name }}</td>
              </tr> -->
              <tr>
                <th>专业 :</th>
                <td>{{ `${bm.specialtyCode}-${bm.specialtyName}` }}</td>
              </tr>
              <tr>
                <th>毕业考核课程 :</th>
                <td>{{ `${bm.courseCode}-${bm.courseName}` }}</td>
              </tr>
              <template
                v-if="
                  $utils.toTime(config.guidanceStartTime) < curTime &&
                  $utils.toTime(config.guidanceEndTime) > curTime
                "
              >
                <tr>
                  <th>论文标题：</th>
                  <td>
                    <!-- <el-input
                      size="mini"
                      v-model="bm.t_name"
                      name="t_name"
                      id="t_name"
                      class="tm_txts"
                      style="width: 400px"
                    /><span style="color: red">*</span> -->
                    {{ bm.t_name }}
                  </td>
                </tr>
                <!-- <tr>
                  <th>是否是学位论文 :</th>
                  <td>
                    <el-select size="mini" v-model="bm.isDegree">
                      <el-option label="是" :value="1"></el-option>
                      <el-option label="否" :value="0"></el-option>
                    </el-select>
                    <span style="color: red">*</span>
                  </td>
                </tr> -->

                <!-- <tr>
                  <th>电子邮箱：</th>
                  <td>
                    <el-input
                      size="mini"
                      v-model="bm.email"
                      name="u_email"
                      id="u_email"
                      class="tm_txts"
                      style="width: 400px"
                    /><span style="color: red">*</span>
                  </td>
                </tr> -->
              </template>
              <tr>
                <th>论文附件 :</th>
                <td>
                  <template
                    v-if="
                      $utils.toTime(config.guidanceStartTime) < curTime &&
                      $utils.toTime(config.guidanceEndTime) > curTime
                    "
                  >
                    <span id="chugaoInfo"></span>
                    <Upload
                      style="display: none"
                      @success="UploadChange($event, 'chugao')"
                      url="/student/thesis2/uploadFiles"
                      accept=".doc,.docx"
                      id="btn_upload_chugao"
                    />
                    <template v-if="config.isOnlineEdit">
                      <el-button
                        type="primary"
                        size="mini"
                        @click="editThesis('chugao')"
                        v-if="thesis && thesis.id"
                        >在线填写论文</el-button
                      >
                      <el-button
                        type="primary"
                        size="mini"
                        @click="addThesis"
                        v-else
                        >创建论文</el-button
                      >
                    </template>
                    <template v-else>
                      <el-button
                        type="primary"
                        size="mini"
                        @click="beforeUpload('chugao')"
                        >请上传</el-button
                      >
                    </template>

                    <div style="color: red">
                      文件名格式：专业+准考证号+姓名，如：会计010615111345张三.doc
                    </div>
                  </template>
                  <template v-if="$utils.toTime(config.guidanceStartTime) > curTime">
                    <span style="color: #999944">请在时间段内上传</span>
                  </template>
                  <template v-if="$utils.toTime(config.guidanceEndTime) < curTime">
                    <span style="color: red">已过了时间段</span>
                  </template>
                </td>
              </tr>
            </template>

            <template v-if="thesis == null && bm == null && db == null">
              <tr>
                <td
                  colspan="2"
                  style="font-weight: bold; text-align: center; color: red"
                  id="no_thesis"
                >
                  未发现毕业论文报名记录，请与主考学校联系。
                </td>
              </tr>
            </template>
            <template v-if="thesis != null">
              <tr>
                <th>状态 :</th>
                <td>
                  <template v-if="thesis.status == 0"
                    >待上传<span style="margin-left: 10px"
                      >[时间段：
                      {{
                        config.guidanceStartTime | dateFormat("yyyy-MM-dd HH:mm")
                      }}
                      至
                      {{
                        config.guidanceEndTime | dateFormat("yyyy-MM-dd HH:mm")
                      }}
                      ]
                    </span>
                  </template>
                  <template v-if="thesis.status == 1"
                    >待审核<span style="margin-left: 10px"
                      >[时间段：
                      {{
                        config.guidanceStartTime | dateFormat("yyyy-MM-dd HH:mm")
                      }}
                      至
                      {{
                        config.guidanceEndTime | dateFormat("yyyy-MM-dd HH:mm")
                      }}
                      ]
                    </span>
                  </template>
                  <template v-if="thesis.status == 5">待上传终稿</template>
                  <template v-if="thesis.status == 6">已上传终稿</template>
                  <template v-if="thesis.status == 2">审核通过</template>
                  <template v-if="thesis.status == 4">
                    <span style="color: red">打回修改</span>
                    <span style="margin-left: 10px"
                      >[时间段：
                      {{
                        config.guidanceStartTime | dateFormat("yyyy-MM-dd HH:mm")
                      }}
                      至
                      {{
                        config.guidanceEndTime | dateFormat("yyyy-MM-dd HH:mm")
                      }}
                      ]
                    </span>
                  </template>
                  <template v-if="thesis.status == 3">
                    <span style="color: red"
                      >审核不通过，已失去本批次论文答辩资格</span
                    >
                  </template>
                  <!-- <template v-if="thesis.status == 6">
                    <span style="color: red">
                      评阅待确认
                      <template v-if="config.markUpdateEndDate < curTime">
                        （已截止）
                      </template>
                    </span>
                    <span style="margin-left: 10px">
                      [评阅修改截止时间：
                      {{
                        config.markUpdateEndDate
                          | dateFormat("yyyy-MM-dd HH:mm")
                      }}
                      ]
                    </span>
                  </template> -->
                </td>
              </tr>
              <tr v-if="thesis.status == 2 && thesis.score">
                <th>成绩 :</th>
                <td>{{ thesis.score }}</td>
              </tr>
              <tr>
                <th>主考学校 :</th>
                <td>{{ `${thesis.schoolCode}-${thesis.schoolName||thesis.schName}` }}</td>
              </tr>
              <!-- <tr>
                <th>学院 :</th>
                <td>{{ thesis.college_name }}</td>
              </tr> -->
              <tr v-if="bm && bm.teacherName && bm.teacherPhone">
                <th>指导老师:</th>
                <td style="color: red;">
                  {{ bm.teacherName }}({{ bm.teacherPhone }}) 论文相关问题，请与老师联系。
                </td>
              </tr>
              <tr>
                <th>专业 :</th>
                <td>{{ `${thesis.specialtyCode}-${thesis.specialtyName}` }}</td>
              </tr>
              <tr>
                <th>毕业考核课程 :</th>
                <td>{{ `${thesis.courseCode}-${thesis.courseName}` }}</td>
              </tr>
              <template v-if="thesis.status == 0">
                <template
                  v-if="
                    $utils.toTime(config.guidanceStartTime) < curTime &&
                    $utils.toTime(config.guidanceEndTime) > curTime &&
                    !config.isOnlineEdit
                  "
                >
                  <tr>
                    <th>论文标题 :</th>
                    <td>
                      <!-- <el-input
                        size="mini"
                        v-model="thesis.name"
                        name="t_name"
                        id="t_name"
                        class="tm_txts"
                        style="width: 400px"
                      /><span style="color: red">*</span> -->
                      {{ thesis.name }}
                    </td>
                  </tr>
                  <!-- <tr>
                    <th>是否是学位论文 :</th>
                    <td>
                      <el-select size="mini" v-model="thesis.isDegree">
                        <el-option label="是" :value="1"></el-option>
                        <el-option label="否" :value="0"></el-option>
                      </el-select>
                      <span style="color: red">*</span>
                    </td>
                  </tr> -->

                  <!-- <tr>
                    <th>电子邮箱：</th>
                    <td>
                      <el-input
                        size="mini"
                        v-model="thesis.email"
                        name="u_email"
                        id="u_email"
                        class="tm_txts"
                        style="width: 400px"
                      /><span style="color: red">*</span>
                    </td>
                  </tr> -->
                </template>
                <template
                  v-if="
                    $utils.toTime(config.guidanceStartTime) > curTime ||
                    $utils.toTime(config.guidanceEndTime) < curTime ||
                    config.isOnlineEdit
                  "
                >
                  <tr>
                    <th>论文标题 :</th>
                    <td>{{ thesis.name }}</td>
                  </tr>
                  <!-- <tr>
                    <th>是否是学位论文 :</th>
                    <td>
                      {{ thesis.isDegree | f("whether") }}
                    </td>
                  </tr> -->
                </template>
                <tr>
                  <th>论文附件 :</th>
                  <td>
                    <span id="chugaoInfo" v-if="thesis.firstAttPath"
                      ><a :href="thesis.firstAttPath" target="_blank">{{
                        thesis.firstAttName
                      }}</a
                      >（文件大小：{{ thesis.firstAttShowSize }}）</span
                    >
                    <template
                      v-if="
                        $utils.toTime(config.guidanceStartTime) < curTime &&
                        $utils.toTime(config.guidanceEndTime) > curTime
                      "
                    >
                      <template v-if="config.isOnlineEdit">
                        <el-button
                          type="primary"
                          size="mini"
                          @click="editThesis('chugao')"
                          v-if="thesis && thesis.id"
                          >在线填写论文</el-button
                        >
                      </template>

                      <template v-if="!config.isOnlineEdit">
                        <Upload
                          style="display: none"
                          @success="UploadChange($event, 'chongchuan')"
                          url="/student/thesis2/uploadFiles"
                          accept=".doc,.docx"
                          id="btn_upload_chongchuan"
                        />
                        <el-button
                          type="primary"
                          size="mini"
                          @click="beforeUpload('chongchuan')"
                          >重传</el-button
                        >
                      </template>

                      <!-- 已有查重报告 -->
                      <template v-if="dcReportStatus || dcAttPath">
                        <a
                          href="javascript:void(0);"
                          style="color: #6495ed; margin-left: 10px"
                          @click="dcReport(reportLogId)"
                          >查重报告</a
                        >
                      </template>
                      <template v-if="dcUnderway">
                        （查重中）
                        <el-button
                          size="mini"
                          class="send"
                          type="primary"
                          @click="refreshDc(thesis.id)"
                          >刷新查重结果</el-button
                        >
                      </template>
                      <template
                        v-if="
                          needFinalDc &&
                          !reportLogId && !dcUnderway && thesis.firstAttPath
                        "
                      >
                        <el-button
                          class="send"
                          type="primary"
                          id="precheck"
                          @click="
                            doPrecheck(
                              thesis.id,
                              thesis.firstAttPath,
                              'dcChugao',
                              '0'
                            )
                          "
                          style="margin-left: 10px;"
                          size="mini"
                          >查重</el-button
                        >
                      </template>
                      <!-- 格式校验 -->
                      <span style="margin-left: 10px;">
                        <template v-if="fvReportLogId">
                          <a
                            href="javascript:void(0);"
                            style="color: #6495ed;"
                            @click="fvReport(fvReportLogId)"
                            >校验报告</a
                          >
                        </template>
                        <template v-if="fvUnderway">
                          （校验中）
                          <el-button
                            size="mini"
                            class="send"
                            type="primary"
                            @click="refreshDc(thesis.id)"
                          >
                            刷新校验结果
                          </el-button>
                        </template>
                        <!-- <template v-if="!fvReportLogId && !fvUnderway && thesis.firstAttPath">
                          <el-button type="primary" size="mini"
                            @click="doPrecheck(
                              thesis.id,
                              thesis.firstAttPath,
                              'formatVerify',
                              '0'
                            )"
                          >格式校验</el-button>
                        </template> -->
                      </span>
                      <!--  -->
                      <div style="color: red">
                        文件名格式：专业+准考证号+姓名，如：会计010615111345张三.doc
                      </div>
                    </template>
                    <template v-if="$utils.toTime(config.guidanceStartTime) > curTime">
                      <span style="color: #999944">请在时间段内上传</span>
                    </template>
                  </td>
                </tr>
                <template v-if="thesis.firstAttCfl != null">
                  <tr>
                    <th>重复率 :</th>
                    <td>{{ thesis.firstAttCfl }}%</td>
                  </tr>
                </template>
                <!-- <template v-if="thesis.score">
                  <tr>
                    <th>评阅得分 :</th>
                    <td>{{ thesis.score }}</td>
                  </tr>
                </template> -->
              </template>
              <template v-if="thesis.status != 0">
                <tr>
                  <th>论文标题 :</th>
                  <td>{{ thesis.name }}</td>
                </tr>
                <!-- <tr>
                  <th>是否是学位论文 :</th>
                  <td>
                    {{ thesis.isDegree | f("whether") }}
                  </td>
                </tr> -->
                <tr>
                  <th>论文附件 :</th>
                  <td>
                    <template v-if="thesis.firstAttPath">
                      <a :href="thesis.firstAttPath" target="_blank">{{
                        thesis.firstAttName
                      }}</a
                      >（文件大小：{{ thesis.firstAttShowSize }}）
                      <!-- 已有查重报告：线上 dcReport / 线下 dcAttPath / 查重日志 / 已有重复率 -->
                       <template v-if="thesis.status < 5">
                        <a
                          v-if="showDcReportLink || thesis.firstAttCfl != null"
                          href="javascript:void(0);"
                          style="color: #6495ed; margin-left: 10px"
                          @click="dcReport(resolvedReportLogId)"
                          >查重报告</a
                        >
                      <template v-if="thesis.status == 1 || thesis.status == 6">
                        <template v-if="dcUnderway">
                          （查重中）
                          <el-button
                            size="mini"
                            class="send"
                            type="primary"
                            @click="refreshDc(thesis.id)"
                            >刷新查重结果</el-button
                          >
                        </template>
                        <!-- 线上查重：提交后仍可发起/补查重；线下查重：提交后不再显示查重按钮 -->
                        <template
                          v-if="
                            isOnlineDc &&
                            !reportLogId &&
                            !dcUnderway &&
                            thesis.firstAttPath
                          "
                        >
                          <el-button
                            class="send"
                            type="primary"
                            id="precheck"
                            @click="
                              doPrecheck(
                                thesis.id,
                                thesis.firstAttPath,
                                'dcChugao',
                                '0'
                              )
                            "
                            style="margin-left: 10px;"
                            size="mini"
                            >查重</el-button
                          >
                        </template>
                      </template>
                      <span style="margin-left: 10px;">
                        <template v-if="fvUnderway">
                          （校验中）
                          <el-button
                            size="mini"
                            class="send"
                            type="primary"
                            @click="refreshDc(thesis.id)"
                            >刷新校验结果</el-button
                          >
                        </template>
                      </span>
                       </template>
                    </template>

                    <template v-if="!thesis.firstAttPath">
                      <span style="color: red">未上传</span>
                    </template>
                  </td>
                </tr>
                <template v-if="thesis.firstAttCfl != null">
                  <tr>
                    <th>重复率 :</th>
                    <td>{{ thesis.firstAttCfl }}%</td>
                  </tr>
                </template>
                <!-- <template v-if="thesis.score">
                  <tr>
                    <th>评阅得分 :</th>
                    <td>{{ thesis.score }}</td>
                  </tr>
                </template> -->
              </template>
              <template v-if="thesis.status == 0">
                <tr>
                  <th>操作 :</th>
                  <td>
                    <el-button
                      size="mini"
                      class="send"
                      type="primary"
                      @click="toSubmit()"
                    >
                      提交
                    </el-button>
                  </td>
                </tr>
              </template>
            </template>

            <template v-if="db != null && thesis != null && thesis.status == 2">
              <tr>
                <th>答辩状态 :</th>
                <td>
                  <template v-if="db.dbStatus == 0"
                    >待上传（待答辩）
                    <!-- 待答辩   未到答辩时间  -->
                    <template
                      v-if="
                        config.dbStartDate && curTime < $utils.toTime(config.dbStartDate)
                      "
                    >
                      <span style="margin-left: 10px; color: red"
                        >[时间段：
                        {{
                          config.dbStartDate | dateFormat("yyyy-MM-dd HH:mm")
                        }}
                        至
                        {{
                          config.dbEndDate | dateFormat("yyyy-MM-dd HH:mm")
                        }}
                        ]
                      </span>
                    </template>
                    <!-- 待答辩   答辩时间已经截止  -->
                    <template
                      v-if="config.dbEndDate && curTime > $utils.toTime(config.dbEndDate)"
                    >
                      <span style="margin-left: 10px; color: red"
                        >[时间段：
                        {{
                          config.dbStartDate | dateFormat("yyyy-MM-dd HH:mm")
                        }}
                        至
                        {{
                          config.dbEndDate | dateFormat("yyyy-MM-dd HH:mm")
                        }}
                        ]
                      </span>
                      <span style="color: red">答辩已经截止</span>
                    </template>
                    <!--带答辩    答辩时间之内  答辩未提交 且已经设置为线上答辩 -->
                    <template
                      v-if="
                        curTime >= $utils.toTime(config.dbStartDate) &&
                        curTime <= $utils.toTime(config.dbEndDate)
                      "
                    >
                      <template
                        v-if="
                          thesis.isOnlineReply &&
                          thesis.isOnlineReply == 1
                        "
                      >
                        <!-- <el-button
                          type="primary"
                          size="mini"
                          style="margin-left: 30px"
                          @click="toOnlineDefense"
                          >进入线上答辩</el-button
                        > -->
                      </template>
                    </template>
                  </template>
                  <!-- 当答辩完成时，3、答辩完成 、1、答辩通过   2、答辩不通过    -->
                  <template
                    v-if="db.dbStatus == 3 || db.dbStatus == 1 || db.dbStatus == 2"
                  >
                    答辩完成
                    <!-- 未到答辩成绩公示时间-->
                    <template v-if="curTime < $utils.toTime(config.cjgsDate)">
                      <span style="margin-left: 10px; color: red"
                        >[成绩公布时间：{{
                          config.cjgsDate | dateFormat("yyyy-MM-dd HH:mm")
                        }}]
                      </span>
                    </template>
                  </template>
                </td>
              </tr>
            </template>

            <template v-if="db != null && thesis == null">
              <tr>
                <th>答辩状态 :</th>
                <td>
                  <template v-if="db.dbStatus == 0"
                    >待上传（待答辩）<span style="margin-left: 10px; color: red"
                      >[时间段：
                      {{
                        config.dbStartDate | dateFormat("yyyy-MM-dd HH:mm")
                      }}
                      至
                      {{ config.dbEndDate | dateFormat("yyyy-MM-dd HH:mm") }}
                      ]
                    </span>
                  </template>
                  <!-- 当答辩完成时，3、答辩完成 、1、答辩通过   2、答辩不通过    -->
                  <template
                    v-if="db.dbStatus == 3 || db.dbStatus == 1 || db.dbStatus == 2"
                  >
                    答辩完成
                    <!-- 未到答辩成绩公示时间-->
                    <template v-if="curTime < $utils.toTime(config.cjgsDate)">
                      <span style="margin-left: 10px; color: red"
                        >[成绩公布时间：
                        {{
                          config.cjgsDate | dateFormat("yyyy-MM-dd HH:mm")
                        }}]</span
                      >
                    </template>
                  </template>
                </td>
              </tr>
              <tr>
                <th>主考学校 :</th>
                <td>{{db.schoolCode}}-{{db.schoolName||db.schName}}</td>
              </tr>
              <tr v-if="bm && bm.teacherName && bm.teacherPhone">
                <th>指导老师:</th>
                <td style="color: red;">
                  {{ bm.teacherName }}({{ bm.teacherPhone }}) 论文相关问题，请与老师联系。
                </td>
              </tr>
              <tr>
                <th>专业 :</th>
                <td>{{ `${db.specialtyCode}-${db.specialtyName}` }}</td>
              </tr>
              <tr>
                <th>毕业考核课程 :</th>
                <td>{{ `${db.courseCode}-${db.courseName}` }}</td>
              </tr>
              <tr>
                <th>论文标题 :</th>
                <td>{{ db.name }}</td>
              </tr>
              <!-- <tr>
                <th>是否是学位论文 :</th>
                <td>
                  {{ db.isDegree | f("whether") }}
                </td>
              </tr> -->
              <template v-if="db.firstAttPath != null">
                <tr>
                  <th>论文附件 :</th>
                  <td>
                    <template v-if="db.firstAttPath">
                      <a :href="db.firstAttPath" target="_blank">下载</a>
                      <template v-if="dcReportStatus || dcAttPath">
                        <a
                          href="javascript:void(0);"
                          style="color: #6495ed"
                          @click="dcReport(reportLogId)"
                          >查重报告</a
                        >
                      </template>
                    </template>
                    <template v-else>
                      <span style="color: red">未上传</span>
                    </template>
                  </td>
                </tr>
              </template>
              <template v-if="db.firstAttCfl != null">
                <tr>
                  <th>重复率 :</th>
                  <td>{{ db.firstAttCfl }}%</td>
                </tr>
              </template>
              <!-- <template v-if="thesis.score">
                <tr>
                  <th>评阅得分 :</th>
                  <td>{{ thesis.score }}</td>
                </tr>
              </template> -->
            </template>
            <template
              v-if="
                db != null &&
                db.grate != null &&
                config.cjgsDate &&
                $utils.toTime(config.cjgsDate) < curTime &&
                (db.status == 1 || db.status == 2)
              "
            >
              <tr>
                <th>论文答辩成绩 :</th>
                <td>
                  <template v-if="db.status == 1"
                    ><span style="color: #009900"
                      >答辩通过&nbsp;&nbsp;&nbsp;&nbsp;成绩：{{
                        db.grate
                      }}分</span
                    ></template
                  >
                  <template v-if="db.status == 2"
                    ><span style="color: red"
                      >答辩不通过&nbsp;&nbsp;&nbsp;&nbsp;成绩：{{
                        db.grate
                      }}分</span
                    ></template
                  >
                </td>
              </tr>
            </template>
            <tr v-if="thesis">
              <th>其他附件 :</th>
              <td>
                <template v-if="thesisAttUrl">
                  <div id="chugaoInfo" v-for="(e, i) in thesisAttUrl" :key="i">
                    <a :href="e" target="_blank">{{thesisAttFileName[i]}}</a>（文件大小：{{ thesisAttSize[i] }}）
                    <i class="el-icon-delete" style="color: red;cursor: pointer;" @click="delthesisAtt(i)" v-if="thesis.status===1 || thesis.status===4"></i>
                  </div>
                </template>
                <template v-if="thesis.status===1 || thesis.status===4">
                  <Upload style="display: none" @success="UploadChange($event, 'submitAtt')"
                    url="/student/thesis2/uploadFiles" accept="" id="btn_upload_submitAtt" />
                  <el-button type="primary" size="mini" @click="beforeUpload('submitAtt')">请上传</el-button>
                </template>
              </td>
            </tr>
          </tbody>
        </table>

        <template
          v-if="
            thesis &&
            thesis.status >= 5 &&
            $utils.toTime(config.guidanceStartTime) < curTime &&
            $utils.toTime(config.guidanceEndTime) > curTime
          "
        >
          <table class="tm_table_form">
            <tr>
              <th>论文终稿</th>
              <td>
                <template v-if="thesis.firstAttPath">
                  <a :href="thesis.firstAttPath" target="_blank">{{
                    thesis.firstAttName
                  }}</a
                  >（文件大小：{{ thesis.firstAttShowSize }}）
                  <template v-if="config.isOnlineEdit && thesis.status == 5">
                    <el-button
                      type="primary"
                      size="mini"
                      @click="editThesis('finalThesis')"
                      v-if="thesis && thesis.id"
                      >在线填写论文</el-button
                    >
                  </template>
                </template>
                <template v-else>
                  <span style="color: red">未上传</span>
                </template>
                <el-button
                  v-if="needFinalDc && !reportLogId && !dcUnderway && !thesis.firstAttCfl && thesis.status == 6"
                  class="send"
                  size="mini"
                  type="primary"
                  id="precheck"
                  @click="
                    doPrecheck(
                      thesis.id,
                      thesis.firstAttPath,
                      'dcChugao',
                      '1'
                    )
                  "
                  style="margin-left: 10px"
                  >查重</el-button
                >
                <template v-if="dcReportStatus || dcAttPath">
                  <a
                    href="javascript:void(0);"
                    style="color: #6495ed"
                    @click="dcReport(reportLogId)"
                    >查重报告</a
                  >
                </template>
                <template v-if="dcUnderway">
                  （查重中）
                  <el-button
                    size="mini"
                    class="send"
                    type="primary"
                    @click="refreshDc(thesis.id)"
                    >刷新查重结果</el-button
                  >
                </template>
              </td>
            </tr>
            <template v-if="thesis.firstAttCfl != null">
              <tr>
                <th>重复率 :</th>
                <td>{{ thesis.firstAttCfl }}%</td>
              </tr>
            </template>
            <template v-if="thesis.finalPaperAuditStatus != null">
              <tr>
                <th>终稿审核状态 :</th>
                <td>{{ finalStatus[thesis.finalPaperAuditStatus] }}</td>
              </tr>
            </template>
            <tr v-if="thesis.status == 6 && thesis.finalPaperAuditStatus != 0 && thesis.finalPaperAuditStatus != 1">
              <th>操作：</th>
              <td>
                <el-button type="primary" size="mini" @click="finnalSubmit"
                >提交审核</el-button
              >
              </td>
            </tr>
            <template v-if="thesis.firstAttCfl != null && thesis.status == 6 && thesis.finalPaperAuditStatus == 1">
              <tr>
                <th>成绩 :</th>
                <td>{{ db.finalScore }}</td>
              </tr>
            </template>
            <template v-if="thesis.processMaterialsUrl != null">
              <tr>
                <th>过程性材料 :</th>
                <td>
                  <a :href="thesis.processMaterialsUrl" target="_blank">下载</a>
                </td>
              </tr>
            </template>
          </table>
        </template>

        <template
          v-if="
            thesis &&
            thesis.status == 4 &&
            $utils.toTime(config.guidanceStartTime) < curTime &&
            $utils.toTime(config.guidanceEndTime) > curTime
          "
        >
          <div
            style="
              margin-top: 20px;
              font-size: 15px;
              text-align: left;
              margin-bottom: 10px;
            "
          >
            回复
            <hr width="80%" style="margin-left: 0px" />
          </div>
          <table class="tm_table_form">
            <tr>
              <th style="width: 200px">回复类型：</th>
              <td>
                <el-radio v-model="submitToAudit.operType" :label="1" @input="oper_type_change4"
                  >重新上传</el-radio
                >
                <!-- <el-radio v-model="submitToAudit.operType" :label="2" @input="oper_type_change4"
                  >论文查重</el-radio
                > -->
                <!-- <el-radio v-model="submitToAudit.operType" :label="3" @input="oper_type_change4"
                  >格式校验</el-radio
                > -->
              </td>
            </tr>
            <tr v-if="submitToAudit.operType == 1">
              <th style="width: 200px">备注</th>
              <td>
                <el-input
                  type="textarea"
                  :rows="4"
                  placeholder=""
                  v-model="submitToAudit.remark"
                >
                </el-input>
              </td>
            </tr>
            <tr v-if="submitToAudit.operType == 1">
              <th>最新版论文<span style="color: red">*</span></th>
              <td style="font-weight: normal">
                <span v-if="submitToAudit.attPath">
                  <a :href="submitToAudit.attPath" target="_blank">{{
                    submitToAudit.attName
                  }}</a>
                  （文件大小：{{ submitToAudit.attSize }}）
                </span>
                <template v-if="config.isOnlineEdit">
                  <el-button
                    type="primary"
                    size="mini"
                    @click="editThesis('submitToAudit')"
                    v-if="thesis && thesis.id"
                    >在线填写论文</el-button
                  >
                </template>

                <template v-else>
                  <Upload
                    style="display: none"
                    @success="UploadChange($event, 'submitToAudit')"
                    url="/student/thesis2/uploadFiles"
                    accept=".doc,.docx"
                    id="btn_upload_submitToAudit"
                  />
                  <el-button
                    type="primary"
                    size="mini"
                    @click="beforeUpload('submitToAudit')"
                    >{{ needFinalDc ? "上传" : "上传并提交" }}</el-button
                  >
                </template>
                <template v-if="needFinalDc && submitToAudit.attPath">
                  <el-button
                    v-if="!dcUnderway && !isCurrentAttDcReady(submitToAudit.attPath)"
                    class="send"
                    type="primary"
                    size="mini"
                    style="margin-left: 10px"
                    @click="
                      doPrecheck(
                        thesis.id,
                        submitToAudit.attPath,
                        'dcChugao',
                        '0'
                      )
                    "
                    >查重</el-button
                  >
                  <a
                    v-if="dcReportStatus || dcAttPath"
                    href="javascript:void(0);"
                    style="color: #6495ed; margin-left: 10px"
                    @click="dcReport(reportLogId)"
                    >查重报告</a
                  >
                  <template v-if="dcUnderway">
                    （查重中）
                    <el-button
                      size="mini"
                      class="send"
                      type="primary"
                      @click="refreshDc(thesis.id)"
                      >刷新查重结果</el-button
                    >
                  </template>
                </template>
                <div style="color: red">
                  文件名格式：专业+准考证号+姓名，如：会计010615111345张三.doc
                </div>
              </td>
            </tr>
            <tr v-if="needFinalDc && submitToAudit.operType == 1">
              <th>操作：</th>
              <td style="font-weight: normal">
                <el-button type="primary" size="mini" @click="submitToAudit_b"
                  >提交给老师审核</el-button
                >
              </td>
            </tr>
            <template v-if="submitToAudit.operType == 2">
              <tr>
                <th>论文附件 :</th>
                <td>
                  <template v-if="thesis.firstAttPath">
                    <a :href="thesis.firstAttPath" target="_blank">{{
                      thesis.firstAttName
                    }}</a
                    >（文件大小：{{ thesis.firstAttShowSize }}）
                  </template>
                  <template v-else>
                    <span style="color: red">未上传</span>
                  </template>
                  <el-button
                  v-if="
                            !reportLogId && !dcUnderway && thesis.firstAttPath
                          "
                    class="send"
                    size="mini"
                    type="primary"
                    id="precheck"
                    @click="
                      doPrecheck(
                        thesis.id,
                        thesis.firstAttPath,
                        'dcChugao',
                        '1'
                      )
                    "
                    style="margin-left: 10px"
                    >查重</el-button
                  >
                  <template v-if="dcReportStatus || dcAttPath">
                        <a
                          href="javascript:void(0);"
                          style="color: #6495ed"
                          @click="dcReport(reportLogId)"
                          >查重报告</a
                        >
                      </template>
                  <template v-if="dcUnderway">
                          （查重中）
                          <el-button
                            size="mini"
                            class="send"
                            type="primary"
                            @click="refreshDc(thesis.id)"
                            >刷新查重结果</el-button
                          >
                        </template>
                </td>
              </tr>
              <tr>
                <th>操作：</th>
                <td>


                  <el-button type="primary" size="mini" @click="toSubmit"
                  >提交给老师审核</el-button
                >
                </td>
              </tr>
            </template>
            <tr class="oper_type3" v-show="submitToAudit.operType == 3">
                <th>操作：</th>
                <td>
                  <el-button
                    size="mini"
                    class="send"
                    type="primary"
                    id="precheck"
                    @click="
                      doPrecheck(
                        thesis.id,
                        thesis.first_att_path||thesis.firstAttPath,
                        'formatVerify',
                        '1'
                      )
                    "
                  >
                    校验并提交
                  </el-button>
                </td>
              </tr>
          </table>
        </template>

        <template
          v-if="
            thesis &&
            thesis.status == 6 &&
            $utils.toTime(config.markUpdateEndDate) > curTime
          "
        >
          <div
            style="
              margin-top: 20px;
              font-size: 15px;
              text-align: left;
              font-weight: bold;
            "
          >
            回复：
            <hr width="80%" style="margin-left: 0px" />
          </div>
          <table
            width="100%"
            cellpadding="5"
            border="0"
            class="tm_table_form"
            style="margin-top: 5px; margin-bottom: 10px"
          >
            <tbody>
              <tr>
                <th style="width: 200px">回复类型：</th>
                <td>
                  <template v-if="!isMarkUpload">
                    <el-radio
                      v-model="submitToAudit.operType"
                      :label="1"
                      @input="oper_type_change"
                      >确认无误</el-radio
                    >
                  </template>
                  <el-radio
                    v-model="submitToAudit.operType"
                    :label="2"
                    @input="oper_type_change"
                    >重新上传</el-radio
                  >
                </td>
              </tr>
              <tr>
                <th>备注：</th>
                <td>
                  <el-input
                    type="textarea"
                    :rows="4"
                    placeholder=""
                    v-model="submitToAudit.remark"
                  >
                  </el-input>
                </td>
              </tr>
              <tr v-if="submitToAudit.operType == 2">
                <th>最新版论文：</th>
                <td style="font-weight: normal">
                  <span v-if="submitToAudit.attPath">
                    <a :href="submitToAudit.attPath" target="_blank">{{
                      submitToAudit.attName
                    }}</a>
                    （文件大小：{{ submitToAudit.attSize }}）
                  </span>
                  <el-button
                    class="send"
                    v-if="this.submitToAudit.attPath"
                    type="info"
                    @click="deleteAttLocalStorage"
                    style="margin-left: 10px"
                    size="mini"
                    >删除</el-button
                  >
                  <template v-if="config.isOnlineEdit">
                    <el-button
                      type="primary"
                      size="mini"
                      @click="editThesis('submitToAudit6')"
                      v-if="!submitToAudit.attPath && thesis && thesis.id"
                      >在线填写论文</el-button
                    >
                  </template>

                  <template v-else>
                    <Upload
                      style="display: inline-block; margin-left: 10px"
                      @success="UploadChange($event, 'submitToAudit6')"
                      url="/student/thesis2/uploadFiles"
                      accept=".doc,.docx"
                    />
                  </template>

                  <el-button
                    class="send"
                    type="primary"
                    @click="markToAffirm(needFinalDc ? '6' : '5')"
                    style="margin-left: 10px"
                    size="mini"
                    >{{ needFinalDc ? "查重并提交" : "提交" }}</el-button
                  >
                  <div style="color: red">
                    文件名格式：专业+准考证号+姓名，如：会计010615111345张三.doc
                  </div>
                </td>
              </tr>
              <tr class="oper_type1" v-if="submitToAudit.operType == 1">
                <th>操作：</th>
                <td>
                  <el-button
                    class="send"
                    type="primary"
                    @click="markToAffirm('2')"
                    size="mini"
                    >提交</el-button
                  >
                </td>
              </tr>
              <!-- <template v-if="isMarkUpload">
                <tr class="oper_type2" v-if="submitToAudit.operType == 2">
                  <th>操作：</th>
                  <td>
                    <el-button
                      class="send"
                      type="primary"
                      @click="markToAffirm('5')"
                      size="mini"
                      >提交</el-button
                    >
                  </td>
                </tr>
              </template> -->
            </tbody>
          </table>
        </template>

        <template v-if="thesisProposal">
          <div style="margin-top: 20px; font-size: 15px; text-align: left">
            开题报告：
            <hr width="80%" style="margin-left: 0px" />
          </div>
          <div style="border-bottom: 1px dashed #babec7">
            <table
              width="100%"
              cellpadding="5"
              border="0"
              class="tm_table_form"
              style="margin-top: 5px; margin-bottom: 10px"
            >
              <tbody>
                <tr>
                  <th style="width: 200px">开题报告提交时间:</th>
                  <td>
                    {{
                      config.guidanceStartTime
                        | dateFormat("yyyy-MM-dd HH:mm")
                    }}
                    至
                    {{
                      config.guidanceEndTime
                        | dateFormat("yyyy-MM-dd HH:mm")
                    }}
                  </td>
                </tr>
                <tr>
                  <th>论文方向:</th>
                  <td style="font-weight: normal">
                    {{ thesisProposal.direction }}
                  </td>
                </tr>
                <tr>
                  <th>题目:</th>
                  <td>{{ thesisProposal.title }}</td>
                </tr>
                <tr>
                  <th>
                    一、论文（设计）选题的依据（选题的目的和意义、该选题在国内外的研究现状及发展趋势、主要参考文献等） :
                  </th>
                  <td>
                    <pre>{{ thesisProposal.outline1 }}</pre>
                  </td>
                </tr>
                <tr>
                  <th>二、论文（设计）的主要研究内容及预期目标 :</th>
                  <td>
                    <pre>{{ thesisProposal.outline2 }}</pre>
                  </td>
                </tr>
                <tr>
                  <th>三、论文（设计）的主要研究方案（拟采用的研究方法、准备工作情况及主要措施） :</th>
                  <td>
                    <pre>{{ thesisProposal.outline3 }}</pre>
                  </td>
                </tr>
                <tr>
                  <th>四、论文（设计）研究工作进展安排 :</th>
                  <td>
                    <pre>{{ thesisProposal.outline4 }}</pre>
                  </td>
                </tr>
                <tr v-if="bm && bm.teacherName && bm.teacherPhone">
                  <th>指导老师:</th>
                  <td style="color: red;">
                    {{ bm.teacherName }}({{ bm.teacherPhone }}) 论文相关问题，请与老师联系。
                  </td>
                </tr>
                <template v-if="thesisProposal.checkStatus != 0">
                  <tr>
                    <th>指导意见:</th>
                    <td>
                      <pre>{{ thesisProposal.remark }}</pre>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </template>
        <template v-if="logs && logs.length">
          <div style="margin-top: 20px; font-size: 15px; text-align: left">
            日志记录：
            <hr width="80%" style="margin-left: 0px" />
          </div>
          <div
            style="border-bottom: 1px dashed #babec7; margin-top: 10px"
            v-for="(e, i) in logs"
            :key="i"
          >
            <table class="tm_table_form">
              <tbody>
                <tr>
                  <th style="width: 200px">操作人</th>
                  <td>{{ e.userName || e.teacherName || e.stuName }}</td>
                  <th style="width: 200px">操作时间</th>
                  <td>{{ e.operTime | dateFormat }}</td>
                </tr>
                <tr>
                  <th>操作描述</th>
                  <td colspan="3">
                    {{ e.operDesc }}
                    <template
                      v-if="
                        e.operType == 'dcChugao' || e.operType == 'dcDinggao'
                      "
                    >
                      <template v-if="e.dcStatus && !e.dcAttPath">
                        <a
                          href="javascript:void(0);"
                          style="color: #6495ed"
                          @click="dcReport(e.id)"
                          >查重报告</a
                        >
                      </template>
                      <template v-if="e.dcAttPath">
                        <a
                          href="javascript:void(0);"
                          style="color: #6495ed"
                          @click="dcReport2(e.dcAttPath)"
                          >查重报告</a
                        >
                      </template>
                      <template v-if="!e.dcStatus && !e.dcAttPath"> （查重中） </template>
                    </template>
                    <!-- 校验 -->
                    <template v-if="e.operType == 'formatVerify'">
                      <template v-if="e.dcStatus">
                        <a
                          href="javascript:void(0);"
                          style="color: #6495ed; margin-left: 10px"
                          @click="fvReport(e.id)"
                          >校验报告</a
                        >
                      </template>
                      <template v-if="!e.dcStatus"> （校验中） </template>
                    </template>
                    <!-- AI智评 -->
                    <template v-if="e.operType == 'paperReview'">
                      <template v-if="thesis.aiCheck == '1'">
                        <span>（AI智评：评审中）</span>
                         <a
                          href="javascript:void(0);"
                          style="color: #6495ed; margin-left: 10px"
                          @click="refreshAiReport"
                          >刷新评审结果</a
                        >
                      </template>
                      <template v-if="thesis.aiCheck == '2'">
                        <span>（AI智评：评审完成）</span>
                        <a
                          href="javascript:void(0);"
                          style="color: #6495ed; margin-left: 10px"
                          @click="aiReport(1)"
                          >AI智评详情</a
                        >
                      </template>
                      <!-- aigc -->
                      <template v-if="thesis.aiAigcCheck == '0'">
                        <span>（AIGC：待检测）</span>
                        <a
                          href="javascript:void(0);"
                          style="color: #6495ed; margin-left: 10px"
                          @click="aigcFn"
                          >生成AIGC报告</a
                        >
                      </template>
                      <template v-if="thesis.aiAigcCheck == '1'">
                         （AIGC报告：检测中）
                      </template>
                      <template v-if="thesis.aiAigcCheck == '2'">
                        <span>（AIGC：检测完成）</span>
                        <a
                          href="javascript:void(0);"
                          style="color: #6495ed; margin-left: 10px"
                          @click="aiReport(2)"
                          >查看AIGC报告</a
                        >
                      </template>

                    </template>
                    <!--  -->
                  </td>
                </tr>

                <tr v-if="e.operRemark">
                  <th>{{ e.operType == "audit" ? "审核意见" : "备注" }}</th>
                  <td colspan="3">
                    <pre>{{ e.operRemark }}</pre>
                  </td>
                </tr>

                <tr v-if="e.attPath && e.operType != 'dcChugao' && e.operType != 'dcDinggao'">
                  <th>文件</th>
                  <td colspan="3">
                    <a :href="e.attPath" target="_blank">{{ e.attName }}</a>
                    （文件大小：{{ e.attShowSize }}）
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </template>
      </div>
    </div>

    <el-dialog
      title="更换手机号码"
      :visible.sync="dialogFormVisible"
      width="600px"
      center
      top="30vh"
      class="editPhone"
    >
      <el-form :model="phone" label-width="120px" label-suffix=":">
        <el-form-item label="请输入手机号码">
          <el-input v-model="phone.mobilephone" clearable></el-input>
          <el-button @click="getPhoneCode" class="m-l" v-if="smsSecond == 0"
            >获取验证码</el-button
          >
          <el-button class="m-l" v-else>{{ `${smsSecond}秒后重发` }}</el-button>
        </el-form-item>
        <el-form-item label="请输入验证码">
          <el-input v-model="phone.checkcode" clearable></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="margin-bottom: 40px">
        <el-button type="primary" @click="handlePhone">确 定</el-button>
        <el-button @click="closeDialog">取 消</el-button>
      </div>
    </el-dialog>
    <DcReport ref="DcReport" />
    <RegisteredPayDialog
      ref="RegisteredPayDialog"
      @refresh="getInfo"
      @ok="_doPrecheck"
    ></RegisteredPayDialog>
    <!-- <faceRecognition
      ref="faceRecognition"
      type="zxdb"
      @submit="waitFn"
    ></faceRecognition> -->
    <Notice ref="Notice" />
    <FvReport ref="fvReport" />

    <UploadReport ref="uploadReportRef" @refresh="onDcUploaded"></UploadReport>
    <TitleEditDialog ref="TitleEditDialog" @success="getInfo" />
  </div>
</template>

<script>
import UploadReport from './UploadReport.vue';

export default {
  name: "",
  components: {
    Notice: () => import("./Notice.vue"),
    DcReport: () => import("./dcReport.vue"),
    RegisteredPayDialog: () => import("./RegisteredPayDialog.vue"),
    FvReport: () => import("./fvReport.vue"),
    UploadReport,
    TitleEditDialog: () => import("./thesisproposal2/TitleEditDialog.vue"),
    // faceRecognition: () =>
    //   import("@/components/faceRecognition/faceRecognition.vue")
  },
  computed: {
    /** 接口 needFinalDc：1 首次/打回/终稿/评阅重传须先查重，0 或不返回则不强制 */
    needFinalDc() {
      const raw =
        (this.config && this.config.needFinalDc) ??
        (this.thesis && this.thesis.needFinalDc) ??
        this.info.needFinalDc;
      return Number(raw) === 1;
    },
    /** 批次启用在线查重 */
    isOnlineDc() {
      return Number(this.config && this.config.isOnlineDc) === 1;
    },
    latestDcLog() {
      const logs = this.logs || [];
      for (let i = logs.length - 1; i >= 0; i--) {
        const e = logs[i];
        if (e && (e.operType == "dcChugao" || e.operType == "dcDinggao")) {
          return e;
        }
      }
      return null;
    },
    resolvedDcAttPath() {
      const t = this.thesis || {};
      return (
        this.dcAttPath ||
        t.dcAttPath ||
        t.dcReportUrl ||
        t.firstAttDcPath ||
        (this.latestDcLog && this.latestDcLog.dcAttPath) ||
        ""
      );
    },
    resolvedReportLogId() {
      const t = this.thesis || {};
      return (
        this.reportLogId ||
        t.reportLogId ||
        t.dcLogId ||
        (this.latestDcLog && this.latestDcLog.id) ||
        ""
      );
    },
    /** 有报告文件/日志，或已有重复率（提交后接口常只回 firstAttCfl） */
    showDcReportLink() {
      const cfl = this.thesis && this.thesis.firstAttCfl;
      const hasCfl = cfl !== null && cfl !== undefined && cfl !== "";
      return !!(
        this.resolvedDcAttPath ||
        this.dcReportStatus ||
        this.resolvedReportLogId ||
        hasCfl
      );
    },
  },
  data() {
    return {
      configs: [],
      info: {},
      defaultThesisBatchId: "",
      config: {},
      thesisProposal: null,
      thesis: null,
      db: null,
      logs: [],
      bm: null,
      isMarkUpload: null,
      curTime: "",
      nowDate: new Date().getTime(),
      form: {},

      dialogFormVisible: false,
      phone: {
        mobilephone: "",
        checkcode: "",
      },
      smsSecond: 0,

      submitToAudit: {
        attPath: "",
        attSize: "",
        attName: "",
        remark: "",
        thesisId: "",
        operType: 1,
      },

      dcAttPath: '',
      reportLogId: "",
      dcReportStatus: "",
      dcCheckedAttPath: "",
      dcUnderway: false,
      dcUploading: false,
      fvReportLogId: "",
      fvUnderway: false,

      currentUserId: this.$store.state.user.userId,
      retdataJson: null,
      dcCb: {},
      thesisId: null,
      //
      formatVerifyTask: null,
      loop: null,
      //
      thesisTempleteUrl:'', //论文资料
      //
      thesisAttUrl:[],
      thesisAttFileName:[],
      thesisAttSize:[],
      finalStatus: {
        0: "待审核",
        1: "审核通过",
        2: "打回修改"
      }
    };
  },
  created() {
    if (this.$route.query.thesisBatchId) this.defaultThesisBatchId = +this.$route.query.thesisBatchId;
    this.getInfo();
  },
  beforeDestroy() {
    if (this.formatVerifyTask != null) {
      clearInterval(this.formatVerifyTask);
    }
    if (this.loop != null) {
      clearInterval(this.loop);
    }
  },
  methods: {
    getInfo() {
      this.$http
        .post("/student/thesis2/myThesis", { thesisBatchId: this.defaultThesisBatchId })
        .then((res) => {
          if (res.bm && !res.bm.t_name && res.thesisProposal) {
            res.bm.t_name = res.thesisProposal.title;
          }

          this.thesisTempleteUrl = res.thesisTempleteUrl
          this.config = res.config;
          this.configs = res.configs;
          this.info = res;
          if (!this.defaultThesisBatchId) this.defaultThesisBatchId = res.defaultThesisBatchId;
          this.thesisProposal = res.thesisProposal;

          // if (res.thesis) res.thesis.firstAttCfl = '10';
          this.thesis = res.thesis;
          //
          if(res.att2List){
              this.thesisAttUrl = res.att2List.map(e=>e.attPath)
              this.thesisAttSize = res.att2List.map(e=>e.attSize)
              this.thesisAttFileName =res.att2List.map(e=>e.attName)
            }
          //
          this.db = res.db;
          this.bm = res.bm;
          this.logs = res.logs;
          this.curTime = res.curTime;
          this.reportLogId =
            res.reportLogId ||
            (res.thesis && (res.thesis.reportLogId || res.thesis.dcLogId)) ||
            "";
          this.dcReportStatus = res.dcReport || (res.thesis && res.thesis.dcReport) || "";
          this.dcAttPath =
            res.dcAttPath ||
            (res.thesis && (res.thesis.dcAttPath || res.thesis.dcReportUrl || res.thesis.firstAttDcPath)) ||
            "";
          if (this.dcAttPath) {
            localStorage.setItem(this.currentUserId + "dcAttPath", this.dcAttPath);
          } else {
            this.dcAttPath = localStorage.getItem(this.currentUserId + "dcAttPath") || "";
          }
          this.dcUnderway = res.dcUnderway || false;
          this.dcUploading = res.dcUploading || false;
          this.fvReportLogId = res.fvReportLogId;
          this.fvUnderway = res.fvUnderway || false;

          this.isMarkUpload = res.isMarkUpload;
          if(this.defaultThesisBatchId)this.$route.query.thesisBatchId=this.defaultThesisBatchId
          if (res.router == "addThesisProposal") {
            this.$router.push({
              path: "/main/addThesisProposal",
              query: { thesisBatchId: this.defaultThesisBatchId },
            });
          } else if (res.router == "myThesisProposal") {
            this.$router.push({
              path: "/main/myThesisProposal",
              query: { thesisBatchId: this.defaultThesisBatchId },
            });
          } else if (res.router == "myThesis") {
            // this.$router.push({
            //   path: "/main/thesis2",
            //   query: { thesisBatchId: this.defaultThesisBatchId },
            // });
            this.gonggao(res.config.notice);
            // 题目被打回修改时强制弹出修改弹窗
            if (res.thesisProposal && !res.thesisProposal.titleAuditStatus) {
              this.$nextTick(() => {
                this.openTitleEditDialog();
              });
            }
          }
          if (this.thesis && this.thesis.status == 4){
            var operType = localStorage.getItem(
              this.currentUserId + "operType4"
            );
            if (operType) {
              this.submitToAudit.operType = +operType;
            }
            const rejectedFile = localStorage.getItem(
              this.currentUserId + "retdata4"
            );
            if (rejectedFile) {
              try {
                const file = JSON.parse(rejectedFile);
                this.submitToAudit.attPath = file.fullpath;
                this.submitToAudit.attSize = file.fileSize || file.fileShowSize;
                this.submitToAudit.attName = file.filename;
                if (file.dcChecked) {
                  this.dcCheckedAttPath = file.dcCheckedAttPath || file.fullpath;
                }
              } catch (e) {}
            }
          }
          if (this.thesis && this.thesis.status == 6) {
            const _retdataJson = localStorage.getItem(
              this.currentUserId + "retdata"
            );
            if (_retdataJson) {
              this.retdataJson = JSON.parse(_retdataJson);
              this.submitToAudit.attPath = this.retdataJson.fullpath;
              this.submitToAudit.attSize = this.retdataJson.fileShowSize;
              this.submitToAudit.attName = this.retdataJson.filename;
              if (this.retdataJson.dcChecked) {
                this.dcCheckedAttPath =
                  this.retdataJson.dcCheckedAttPath || this.retdataJson.fullpath;
              }
              if (this.isMarkUpload) {
                this.submitToAudit.operType = 1;
              }
            } else {
              localStorage.setItem(this.currentUserId + "operType", 2);
            }
            var operType = localStorage.getItem(
              this.currentUserId + "operType"
            );
            if (operType) {
              this.submitToAudit.operType = +operType;
            }
          }
        });
    },
    oper_type_change() {
      localStorage.setItem(
        this.currentUserId + "operType",
        this.submitToAudit.operType
      );
    },
    oper_type_change4() {
      localStorage.setItem(
        this.currentUserId + "operType4",
        this.submitToAudit.operType
      );
    },
    gonggao(n) {
      const hasNoticeContent = (content) => {
        if (!content) return false;
        const text = String(content)
          .replace(/<[^>]+>/g, "")
          .replace(/&nbsp;/gi, " ")
          .trim();
        return !!text;
      };
      if (
        hasNoticeContent(n) &&
        (!this.config.noticeEndDate || this.$utils.toTime(this.config.noticeEndDate) > this.nowDate)
      ) {
        const u_id = this.$store.state.user.userId + "2";
        if (!sessionStorage.getItem(u_id) && n) {
          this.$refs.Notice.open(n, () => {
            sessionStorage.setItem(u_id, "1");
          });
          // this.$alert(n, "考生论文须知", {
          //   dangerouslyUseHTMLString: true,
          //   customClass: "msgBox",
          // });
        }
      }
    },
    openTitleEditDialog() {
      if (!this.$refs.TitleEditDialog) return;
      const proposal = this.thesisProposal || {};
      const bm = this.bm || {};
      this.$refs.TitleEditDialog.open({
        thesisProposalId: proposal.id,
        thesisBatchId: this.defaultThesisBatchId,
        courseId: bm.courseId || proposal.courseId,
        questionId: proposal.questionId,
      });
    },
    UploadChange(e, t) {
      const _t = this;
      if (t == "submitToAudit") {
        this.submitToAudit.attPath = e.fullpath;
        this.submitToAudit.attSize = e.fileSize;
        this.submitToAudit.attName = e.filename;
        if (this.needFinalDc) {
          this.clearCachedDcAttPath();
          this.dcCheckedAttPath = "";
          this.writeRejectedFileCache({
            ...e,
            dcChecked: false,
            dcCheckedAttPath: "",
          });
          this.$message({
            showClose: true,
            message: "上传成功，请查重后再提交。",
            type: "success",
          });
        } else {
          this.submitToAudit_b();
        }
      } else if (t == "chugao") {
        const params = {
          chugaoUrl: e.fullpath,
          chugaoSize: e.fileSize,
          thesisBatchId: _t.defaultThesisBatchId,
          name: _t.bm.t_name,
          // isDegree: _t.bm.isDegree,
          email: _t.bm.email,
          teacherId: _t.thesisProposal?.teacherId,
        };
        this.$http.post("/student/thesis2/saveChugao", params,{isQs:1}).then((res) => {
          if (res) {
            _t.getInfo();
          }
        });
      } else if (t == "chongchuan") {
        const params = {
          chugaoUrl: e.fullpath,
          chugaoSize: e.fileSize,
          thesisBatchId: _t.defaultThesisBatchId,
          name: _t.thesis.name,
          // isDegree: _t.thesis.isDegree,
          email: _t.thesis.email,
        };
        this.$http.post("/student/thesis2/saveChugao", params,{isQs:1}).then((res) => {
          if (res) {
            _t.getInfo();
          }
        });
      } else if (t == "submitToAudit6") {
        this.submitToAudit.attPath = e.fullpath;
        this.submitToAudit.attSize = e.fileShowSize;
        this.submitToAudit.attName = e.filename;
        this.dcCheckedAttPath = "";
        localStorage.setItem(
          this.currentUserId + "retdata",
          JSON.stringify({
            ...e,
            dcChecked: this.needFinalDc ? false : true,
            dcCheckedAttPath: "",
          })
        );
      }else if(t == 'submitAtt'){
        //
        _t.thesisAttUrl.push(e.fullpath)
        _t.thesisAttSize.push(e.fileShowSize)
        _t.thesisAttFileName.push(e.filename)
        //
        const params = {
          thesisAttUrl: _t.thesisAttUrl,
          thesisId: _t.thesis.id,
          thesisAttFileName: _t.thesisAttFileName,
          thesisAttSize: _t.thesisAttSize
        };
        this.$http.post("/student/thesis2/submitAtt", params).then((res) => {
          console.log(res)
          _t.getInfo();
        });


      }
    },
    beforeUpload(t) {
      if (t == "chugao") {
        if (!this.bm.t_name) {
          this.$message({
            showClose: true,
            message: "请先填写论文标题。",
            type: "error",
          });
          return;
        }
        // if (
        //   this.bm.isDegree === undefined ||
        //   this.bm.isDegree === null ||
        //   this.bm.isDegree === ""
        // ) {
        //   this.$message({
        //     showClose: true,
        //     message: "请先选择是否学位论文。",
        //     type: "error",
        //   });
        //   return;
        // }
        // if (!this.bm.email) {
        //   this.$message({
        //     showClose: true,
        //     message: "请先填写电子邮箱。",
        //     type: "error",
        //   });
        //   return;
        // }
        document
          .getElementById("btn_upload_" + t)
          .getElementsByClassName("el-upload__input")[0]
          .click();
      }
      if (t == "chongchuan") {
        if (!this.thesis.name) {
          this.$message({
            showClose: true,
            message: "请先填写论文标题。",
            type: "error",
          });
          return;
        }
        // if (
        //   this.thesis.isDegree === undefined ||
        //   this.thesis.isDegree === null ||
        //   this.thesis.isDegree === ""
        // ) {
        //   this.$message({
        //     showClose: true,
        //     message: "请先选择是否学位论文。",
        //     type: "error",
        //   });
        //   return;
        // }
        // if (!this.thesis.email) {
        //   this.$message({
        //     showClose: true,
        //     message: "请先填写电子邮箱。",
        //     type: "error",
        //   });
        //   return;
        // }
        document
          .getElementById("btn_upload_" + t)
          .getElementsByClassName("el-upload__input")[0]
          .click();
      }
      if (t == "submitToAudit") {
        this.$confirm("重新上传将会覆盖现有论文，是否继续！", "提示", {
          confirmButtonText: "继续",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then((r) => {
            document
              .getElementById("btn_upload_" + t)
              .getElementsByClassName("el-upload__input")[0]
              .click();
          })
          .catch((action) => {});
      }
      if(t==='submitAtt'){
        document
          .getElementById("btn_upload_" + t)
          .getElementsByClassName("el-upload__input")[0]
          .click();
      }
    },
    closeDialog() {
      this.dialogFormVisible = false;
      this.phone = {
        mobilephone: "",
        checkcode: "",
      };
      this.getInfo();
    },
    handlePhone() {
      if (!this.phone.mobilephone) {
        this.$message({
          message: "请输入手机号!",
          type: "error",
        });
        return;
      }
      if (!this.phone.checkcode) {
        this.$message({
          message: "请输入验证码!",
          type: "error",
        });
        return;
      }
      this.$http
        .post("/user/common/updatePhone", { ...this.phone })
        .then((res) => {
          console.log(res);
          this.$message({
            message: "操作成功",
            type: "success",
          });
          this.closeDialog();
        });
    },
    getPhoneCode() {
      if (!this.phone.mobilephone) {
        this.$message({
          message: "请输入手机号!",
          type: "error",
        });
        return;
      }
      this.$http
        .post("/user/common/getPhoneCheckCode", {
          mobilephone: this.phone.mobilephone,
        })
        .then((res) => {
          if (res) {
            if (this.intervalTime) {
              this.intervalTime = null;
            }
            this.smsSecond = 60;
            this.intervalTime = setInterval(() => {
              if (this.smsSecond == 0) {
                clearInterval(this.intervalTime);
              } else {
                this.smsSecond--;
              }
            }, 1000);
            this.$message({
              message: "操作成功",
              type: "success",
            });
          } else {
            this.$message({
              message: res.msg,
              type: "error",
            });
          }
        });
    },

    // submitToAuditb() {
    //   const params = {
    //     ...this.submitToAudit,
    //     thesisId: this.thesis.id,
    //     isSpotCheck:0
    //   };
    //   if (!params.attPath) {
    //     this.$message({
    //       showClose: true,
    //       message: "请先上传最新版论文后再操作！",
    //       type: "error",
    //     });
    //     return;
    //   }
    //   const _t = this;
    //   this.$confirm("确定提交审核?", "提示", {
    //     confirmButtonText: "确定",
    //     cancelButtonText: "取消",
    //     type: "warning",
    //   })
    //     .then(() => {
    //       _t.$http
    //         .post("/student/thesis2/submitToAudit", params,{isQs:1})
    //         .then((res) => {
    //           if (res) {
    //             this.$message({
    //               showClose: true,
    //               message: "提交成功，等待指导老师审核。",
    //               type: "success",
    //             });
    //             _t.getInfo();
    //           }
    //         });
    //     })
    //     .catch(() => {});
    // },
    hasDcResult() {
      const cfl = this.thesis && this.thesis.firstAttCfl;
      return cfl !== null && cfl !== undefined && cfl !== "";
    },
    hasDcReport() {
      return !!(
        this.resolvedDcAttPath ||
        this.dcReportStatus ||
        this.resolvedReportLogId
      );
    },
    clearCachedDcAttPath() {
      localStorage.removeItem(this.currentUserId + "dcAttPath");
      this.dcAttPath = "";
    },
    rejectedFileCacheKey() {
      if (this.thesis && this.thesis.status == 6) return this.currentUserId + "retdata";
      return this.currentUserId + "retdata4";
    },
    readRejectedFileCache() {
      try {
        const raw = localStorage.getItem(this.rejectedFileCacheKey());
        return raw ? JSON.parse(raw) : null;
      } catch (e) {
        return null;
      }
    },
    writeRejectedFileCache(data) {
      localStorage.setItem(this.rejectedFileCacheKey(), JSON.stringify(data));
    },
    markAttDcChecked(attPath) {
      if (!attPath) return;
      this.dcCheckedAttPath = attPath;
      const cache = this.readRejectedFileCache() || {};
      this.writeRejectedFileCache({
        ...cache,
        fullpath: cache.fullpath || attPath,
        dcChecked: true,
        dcCheckedAttPath: attPath,
      });
    },
    isNewAttPendingDc(attPath) {
      if (!attPath) return false;
      const cache = this.readRejectedFileCache();
      if (!cache || cache.fullpath !== attPath) return false;
      return cache.dcChecked === false;
    },
    isCurrentAttDcReady(attPath) {
      if (!this.needFinalDc) return true;
      if (!attPath) return this.hasDcResult();
      if (this.isNewAttPendingDc(attPath)) return false;
      if (this.dcCheckedAttPath === attPath) return true;
      if (this.thesis && attPath === this.thesis.firstAttPath && this.hasDcResult()) {
        return true;
      }
      // 旧缓存未标记 dcChecked：已有重复率+报告则放行（兼容已上传查重报告的当前记录）
      return this.hasDcResult() && this.hasDcReport();
    },
    onDcUploaded() {
      this.markAttDcChecked(
        this.submitToAudit.attPath || (this.thesis && this.thesis.firstAttPath)
      );
      this.getInfo();
    },
    submitToAudit_b() {
      const params = {
        ...this.submitToAudit,
        thesisId: this.thesis.id,
        isSpotCheck:0
      };
      if (!params.attPath) {
        this.$message({
          showClose: true,
          message: "请先上传最新版论文后再操作！",
          type: "error",
        });
        return;
      }
      if (this.needFinalDc && !this.isCurrentAttDcReady(params.attPath)) {
        this.$message({
          showClose: true,
          message: this.hasDcResult()
            ? "重新上传的论文，必须查重后才能提交！"
            : "请查重后再操作。",
          type: "warning",
        });
        return;
      }
      const _t = this;
      const doSubmit = () => {
        _t.$http.post("/student/thesis2/submitToAudit", params,{isQs:1}).then((res) => {
          if (res) {
            localStorage.removeItem(_t.currentUserId + "retdata4");
            this.$message({
              showClose: true,
              message: "提交成功，等待指导老师审核。",
              type: "success",
            });
            _t.thesisReview();
          }
        });
      };
      if (this.needFinalDc) {
        this.$confirm("是否确定提交给老师审核吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(doSubmit)
          .catch(() => {});
      } else {
        doSubmit();
      }
    },

    toOnlineDefense() {
      // this.$router.push({
      //   path: "/main/online-defense-form",
      //   query: {
      //     thesisId: this.db.thesisId,
      //   },
      // });
      const thesisId = this.db.thesisId;
      this.thesisId = thesisId;
      this.$refs.faceRecognition.open({
        thesisId,
      });
    },
    waitFn(photoPath) {
      this.$http
        .post("/student/thesis2/enterOnlineReply", {
          thesisId: this.thesisId,
          photoPath,
        })
        .then((res) => {
          this.$store.state.roomData = res;
          const { href } = this.$router.resolve({
            path: "/online-defense-room",
            query: { roomId: res.dbRoomId },
          });
          window.open(href, "_blank");
        });
    },
    dcReport(reportLogId) {
      const attPath = this.resolvedDcAttPath;
      if (attPath) {
        let url=decodeURIComponent(attPath)
        const a = document.createElement("a");
        a.href = url;
        a.target = "_blank";
        a.download = url;
        a.style.display = "none";
        document.body.append(a);
        a.click();
        document.body.removeChild(a);
        return
      }
      const logId = reportLogId || this.resolvedReportLogId;
      if (!logId) {
        this.$message({
          showClose: true,
          message: "暂未获取到查重报告",
          type: "warning",
        });
        return;
      }
      //查重报告
      this.$http
        .post("/student/thesis2/dcReport", { logId },{isQs:1})
        .then(res => {
      this.$refs.DcReport.open(res);
      });
    },
    refreshDc(thesisId) {
      this.$http
        .get("/student/thesis2/refreshDc", { thesisId })
        .then((res) => {
          if (res) {
            this.getInfo();
          }
        });
    },
    dcReport2(dcAttPath) {
        let url=decodeURIComponent(dcAttPath)
        const a = document.createElement("a");
        a.href = url;
        a.target = "_blank";
        a.download = url;
        a.style.display = "none";
        document.body.append(a);
        a.click();
        document.body.removeChild(a);
        return
    },
    //先校验是否超过免费查重次数
    doPrecheck(thesisId, attPath, operType, needSubmit) {
      const _t = this;
      const { guidanceStartTime, guidanceEndTime, isOnlineDc } = this.config;
      if (needSubmit === "0") {
        if (
          guidanceStartTime &&
          guidanceEndTime &&
          !(this.$utils.toTime(guidanceStartTime) < this.curTime && this.$utils.toTime(guidanceEndTime) > this.curTime)
        ) {
          this.$message({
            showClose: true,
            message: "不在查重时间范围内！",
            type: "error",
          });
          return;
        }
      }
      //
      console.log(operType)
      if (isOnlineDc != 1) {
        this.$confirm(
          "当前论文未启用在线查重，需要上传查重报告和填写重复率，是否确定进行论文查重报告上传？",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        )
          .then(() => {
            this.$refs.uploadReportRef.open(thesisId)
          })
          .catch(() => {});
          return
      }
      if (operType == "formatVerify") {
        this.$confirm(
          "格式校验非强制要求，需要支付校验费用，是否确定进行格式校验？",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        )
          .then(() => {
            _t.toThesisDc(
                  thesisId,
                  attPath,
                  operType,
                  null,
                  needSubmit
                );
          })
          .catch(() => {});
      }else{

      this.$confirm(
        "论文查重会覆盖当前重复率，超过免费次数之后需要支付相关费用，是否确定进行论文查重？注意：论文查重最迟24小时内出结果！",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          _t.dcCb = { thesisId, attPath, operType, needSubmit };
          _t.doThesisDcPrecheck(
            "",
            thesisId,
            attPath,
            operType,
            needSubmit,
            function (orderId) {
              _t.toThesisDc(
                thesisId,
                attPath,
                operType,
                orderId,
                needSubmit
              );
            }
          );
        })
        .catch(() => {});
      }
      //

    },
    _doPrecheck() {
      const _t = this;
      const { thesisId, attPath, operType, needSubmit } = this.dcCb;
      console.log(this.dcCb);
      _t.doThesisDcPrecheck(
        "",
        thesisId,
        attPath,
        operType,
        needSubmit,
        function (orderId) {
          _t.toThesisDc(thesisId, attPath, operType, orderId, needSubmit);
        }
      );
    },
    toSubmit() {
      const _t = this;
      if (this.needFinalDc && !this.hasDcResult()) {
        _t.$message({
          showClose: true,
          message: "请查重后再操作。",
          type: "warning",
        });
      } else {
        const params = {
          attPath: _t.thesis.firstAttPath,
          attSize: _t.thesis.firstAttSize,
          remark: "",
          thesisId: _t.thesis.id,
          name: _t.thesis.name,
          // isDegree: _t.thesis.isDegree,
          email: _t.thesis.email,
          isSpotCheck:0
        };
        if (!params.name) {
          this.$message({
            showClose: true,
            message: "请先填写论文标题。",
            type: "error",
          });
          return;
        }
        // if (
        //   params.isDegree === undefined ||
        //   params.isDegree === null ||
        //   params.isDegree === ""
        // ) {
        //   this.$message({
        //     showClose: true,
        //     message: "请先选择是否学位论文。",
        //     type: "error",
        //   });
        //   return;
        // }
        // if (!params.email) {
        //   this.$message({
        //     showClose: true,
        //     message: "请先填写电子邮箱。",
        //     type: "error",
        //   });
        //   return;
        // }
        this.$confirm("是否确定提交给老师审核吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            _t.$http
              .post("/student/thesis2/submitToAudit", params,{isQs:1})
              .then((res) => {
                // if (res) {
                  this.$message({
                    showClose: true,
                    message: "提交成功，等待指导老师审核。",
                    type: "success",
                  });
                  _t.thesisReview();
                // }
              });
          })
          .catch(() => {});
      }
    },
    finnalSubmit() {
      const _t = this;
      if (this.needFinalDc && !this.hasDcResult()) {
        _t.$message({
          showClose: true,
          message: "请查重后再操作。",
          type: "warning",
        });
      } else {
        const params = {
          // attPath: _t.thesis.firstAttPath,
          // attSize: _t.thesis.firstAttSize,
          // remark: "",
          thesisId: _t.thesis.id,
          // name: _t.thesis.name,
          // isDegree: _t.thesis.isDegree,
          // email: _t.thesis.email,
          // isSpotCheck:0
        };
        // if (!params.name) {
        //   this.$message({
        //     showClose: true,
        //     message: "请先填写论文标题。",
        //     type: "error",
        //   });
        //   return;
        // }
        this.$confirm("是否确定提交给老师审核吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            _t.$http
              .post("/student/thesis2/uploadFinalThesis", params,{isQs:1})
              .then((res) => {
                // if (res) {
                  this.$message({
                    showClose: true,
                    message: "提交成功，等待指导老师审核。",
                    type: "success",
                  });
                  _t.thesisReview();
                // }
              });
          })
          .catch(() => {});
      }
    },
    toThesisDc(thesisId, attPath, operType, orderId, needSubmit) {
      const _t = this;
      _t.$http
        .post("/student/thesis2/duplicateChecking", {
          thesisId: thesisId,
          attPath: attPath,
          operType: operType,
          orderId: orderId,
          needSubmit,
        },{isQs:1})
        .then((res) => {
          if (res) {
            if (operType == "formatVerify") {
              var winURL = window.open(res.url);

              const loading = _t.$loading({
                lock: true,
                text: "正在校验中，请耐心等待...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
              });
              //监听打开的页面关闭
              _t.loop = setInterval(function () {
                if (winURL && winURL.closed) {
                  //关掉定时器
                  if (_t.formatVerifyTask != null) {
                    clearInterval(_t.formatVerifyTask);
                  }
                  if (_t.loop != null) {
                    clearInterval(_t.loop);
                  }
                  loading.close();
                  _t.$message({
                    showClose: true,
                    message: "用户取消校验...",
                  });
                }
              }, 1200);

              //1秒一次定时轮训：回调、状态、结果
              _t.formatVerifyTask = setInterval(function () {
                _t.$http
                  .post("/student/thesis2/fvReportResult", {
                    customparameter: res.customparameter,
                  },{isQs:1})
                  .then(res => {
                    if (res) {
                      loading.close();
                      _t.$alert("校验成功，请耐心等待结果！", "", {
                        confirmButtonText: "知道了",
                        callback: action => {
                          if (needSubmit == "1") {
                            _t.$http
                              .post("/student/thesis2/submitToAudit", {
                                attPath: attPath,
                                attSize: _t.thesis.firstAttSize,
                                remark: "",
                                thesisId: thesisId,
                                isSpotCheck: 1,
                              })
                              .then(res => {
                                if (res) {
                                  _t.$message({
                                    showClose: true,
                                    message: "已自动提交给老师审核",
                                    type: "success",
                                  });
                                  _t.thesisReview();
                                }
                              });
                          } else {
                            _t.getInfo();
                          }
                        },
                      });
                      //关掉定时器
                      if (_t.formatVerifyTask != null) {
                        clearInterval(_t.formatVerifyTask);
                      }
                      if (_t.loop != null) {
                        clearInterval(_t.loop);
                      }
                    }
                  });
              }, 1000);
            } else {
              // _t.$message({
              //   showClose: true,
              //   message: "提交成功，请耐心等待结果！",
              //   type: "success",
              // });
              window.open(res)
              return
              if (needSubmit == "1") {
                // _t.$http
                //   .post("/student/thesis2/submitToAudit", {
                //     attPath: attPath,
                //     attSize: _t.thesis.firstAttSize,
                //     remark: "",
                //     thesisId: thesisId,
                //     name: _t.form.name || _t.thesis.name,
                //     // isDegree: _t.form.isDegree || _t.thesis.isDegree,
                //     email: _t.form.email || _t.thesis.email,
                //     needSubmit,
                //     isSpotCheck:0
                //   },{isQs:1})
                //   .then((res) => {
                //     if (res) {
                //       _t.$message({
                //         showClose: true,
                //         message: "已自动提交给老师审核",
                //       });
                      _t.thesisReview()
                  //   }
                  // });
              } else {
                if (needSubmit == "6") {
                  _t.markToAffirm5();
                  _t.deleteAttLocalStorage();
                } else {
                  _t.getInfo();
                }
              }
            }

          }
        });
    },

    //论文查重、校验是否缴费
    async doThesisDcPrecheck(
      tm_base,
      thesisId,
      attPath,
      operType,
      needSubmit,
      callbackFunction
    ) {
      const _t = this;
      var checkResult = await this.verifyPayStatusBeforeThesisDc(
        tm_base,
        thesisId,
        attPath,
        operType
      );
      if (checkResult) {
        callbackFunction(checkResult.orderId);
        return
        //已缴
        if (checkResult.isPaid == "1") {
          // 将订单id返回给回调函数
          callbackFunction(checkResult.orderId);
          // this.dcUploading = true
        } else if (checkResult.isPaid == "0") {
          var str = "当前查重论文未交费，请先缴费！";
          if (operType == "formatVerify") {
            str = "当前格式校验未交费，请先缴费！";
          }
          this.$confirm(str, "提示", {
            confirmButtonText: "立即缴费",
            cancelButtonText: "取消",
            type: "info",
          })
            .then(() => {
              _t.toPayThesisDc(checkResult.orderId, operType, needSubmit);
            })
            .catch(() => {});
        } else {
          var str = "您已超出免费查重次数，需要支付费用继续查重？";
          if (operType == "formatVerify") {
            str = "您已超出免费检测次数，需要支付费用继续查重？";
          }
          this.$confirm(str, "提示", {
            confirmButtonText: "立即缴费",
            cancelButtonText: "取消",
            type: "info",
          })
            .then(() => {
              _t.toPayThesisDc(checkResult.orderId, operType, needSubmit);
            })
            .catch(() => {});
        }
      }
    },
    //论文查重前检查缴费状态相关信息
    async verifyPayStatusBeforeThesisDc(
      tm_base,
      thesisId,
      attPath,
      operType
    ) {
      return await this.$http.post(
        "/student/thesis2/verifyPayStatusBeforeThesisDc",
        {
          thesisId: thesisId,
          attPath: attPath,
          operType: operType,
        },{isQs:1}
      );
    },
    //论文查重支付
    toPayThesisDc(orderId, operType, needSubmit) {
      var str = "论文查重缴费";
      if (operType == "formatVerify") {
        str = "格式校验缴费";
      }

      this.$http
        .post("/student/thesis2/order/detail", { orderId, type:'dc', needSubmit },{isQs:1})
        .then((res_) => {
          this.$refs.RegisteredPayDialog.open(res_,str,'dc');
        });
    },
    // 评阅流程
    markToAffirm(status) {
      const _t = this;
      // 评阅确认
      if (status == "2") {
        if (
          this.thesis.firstAttCfl === null ||
          this.thesis.firstAttCfl === undefined ||
          this.thesis.firstAttCfl === ""
        ) {
          _t.$message({
            showClose: true,
            message: "请查重后再操作。",
            type: "error",
          });
        } else {
          this.$confirm(
            "确认无误后，论文的状态变成审核通过，且无法再修改。是否确定？",
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            }
          ).then(() => {
            this.$http
              .post("/student/thesis2/markToAffirm", {
                remark: _t.submitToAudit.remark,
                thesisId: _t.thesis.id,
                status,
              })
              .then((res) => {
                if (res) {
                  _t.getInfo();

                  _t.$message({
                    showClose: true,
                    message: "提交成功。",
                    type: "success",
                  });
                }
              });
          });
        }
      }
      // 评阅修改提交
      else if (status == "5") {
        if (!this.submitToAudit.attPath) {
          _t.$message({
            showClose: true,
            message: "请重新上传文件再操作。",
            type: "error",
          });
          return false;
        } else if (this.needFinalDc && !this.isCurrentAttDcReady(this.submitToAudit.attPath)) {
          _t.$message({
            showClose: true,
            message: this.hasDcResult()
              ? "重新上传的论文，必须查重后才能提交！"
              : "请查重后再操作。",
            type: "error",
          });
        } else {
          this.$confirm("确认确定提交吗？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            this.$http
              .post("/student/thesis2/markToAffirm", {
                remark: _t.submitToAudit.remark,
                thesisId: _t.thesis.id,
                status,
              })
              .then((res) => {
                if (res) {
                  _t.getInfo();

                  _t.$message({
                    showClose: true,
                    message: "提交成功，等待评阅老师审核。",
                    type: "success",
                  });
                }
              });
          });
        }
      }
      // 评阅上传查重
      else if (status == "6") {
        if (!this.submitToAudit.attPath) {
          _t.$message({
            showClose: true,
            message: "请重新上传文件再操作。",
            type: "error",
          });
          return false;
        }
        // this.$confirm(
        //   "修改上传后老师会重新评阅，但仅允许修改一次，请谨慎操作！",
        //   "提示",
        //   {
        //     confirmButtonText: "确定",
        //     cancelButtonText: "取消",
        //     type: "warning",
        //   }
        // ).then(() => {
        _t.doPrecheck(
          _t.thesis.id,
          this.submitToAudit.attPath,
          "dcChugao",
          status
        );
        // });
      }
    },
    markToAffirm5() {
      const _t = this;
      this.$http
        .post("/student/thesis2/markToAffirm", {
          remark: _t.submitToAudit.remark,
          thesisId: _t.thesis.id,
          status: 5,
        })
        .then((res) => {
          if (res) {
            _t.getInfo();

            _t.$message({
              showClose: true,
              message: "提交成功，等待评阅老师审核。",
              type: "success",
            });
          }
        });
    },
    //删除时清空缓存
    deleteAttLocalStorage() {
      localStorage.removeItem(this.currentUserId + "retdata");
      this.retdataJson = null;
      this.submitToAudit.attPath = "";
      this.submitToAudit.attSize = "";
      this.submitToAudit.attName = "";
      this.$forceUpdate();
    },

    addThesis() {
      if (!this.bm.t_name) {
        this.$message({
          showClose: true,
          message: "请先填写论文标题。",
          type: "error",
        });
        return;
      }
      // if (
      //   this.bm.isDegree === undefined ||
      //   this.bm.isDegree === null ||
      //   this.bm.isDegree === ""
      // ) {
      //   this.$message({
      //     showClose: true,
      //     message: "请先选择是否学位论文。",
      //     type: "error",
      //   });
      //   return;
      // }
      // if (!this.bm.email) {
      //   this.$message({
      //     showClose: true,
      //     message: "请先填写电子邮箱。",
      //     type: "error",
      //   });
      //   return;
      // }
      const _t = this;
      const params = {
        thesisBatchId: _t.defaultThesisBatchId,
        name: _t.bm.t_name,
        // isDegree: _t.bm.isDegree,
        email: _t.bm.email,
        teacherId: _t.thesisProposal?.teacherId,
      };
      this.$http.post("/student/thesis2/createdThesis", params,{isQs:1}).then((res) => {
        if (res) {
          _t.getInfo();
        }
      });
    },
    editThesis(stype) {
      this.$store.state.thesis = {
        ...this.thesis,
        teacherId: this.thesisProposal?.teacherId,
        remark:this.submitToAudit.remark
      };
      this.$router.push({
        path: "/thesis-edit",
        query: {
          thesisId: this.thesis.id,
          stype,
          needFinalDc: this.needFinalDc ? 1 : 0,
        },
      });
    },
    fvReport(logId) {
      this.$http.post("/student/thesis2/fvReport", { logId },{isQs:1}).then(res => {
        this.$refs.fvReport.open(res);
      });
    },
    thesisReview(){
      const _t = this;
      if(_t.config.isOpenAi){
        window.location.reload();
        // _t.$http.post("/thesisApi/thesisReview", {thesisId: _t.thesis.id},{isQs:1}).then((ret) => {
        //   window.location.reload();
        // })
      }else{
        window.location.reload();
      }
    },
    aigcFn(){
      const _t = this;
      _t.$http.post("/thesisApi/aigc", { thesisId: _t.thesis.id },{isQs:1}).then(res => {
        _t.$message.success('操作成功');
        _t.getInfo();
      });
    },
    aiReport(type){
      const _t = this;
      _t.$http.get("/thesisApi/queryAiResult", { thesisId: _t.thesis.id, type,fileUrl:_t.thesis.firstAttPath  },{isQs:1}).then(res => {

        var data = JSON.parse(res)
        if(data){

          let url = decodeURIComponent(data.review_results.review_file_url)
          const a = document.createElement("a");
          a.href = url;
          a.target = "_blank";
          a.download = url;
          a.style.display = "none";
          document.body.append(a);
          a.click();
          document.body.removeChild(a);
        }
      });
    },
    refreshAiReport(){
      const _t = this;
      this.$http.post("/thesisApi/getThesisReviewResult", {},{isQs:1}).then(res => {
        _t.$message.success('刷新成功');
        _t.getInfo();
      });
    },
    delthesisAtt(i) {
      this.thesisAttUrl.splice(i, 1)
      this.thesisAttSize.splice(i, 1)
      this.thesisAttFileName.splice(i, 1)
      this.$forceUpdate()
    },
  },
};
</script>

<style scoped lang="scss">
.tm_required {
  color: #f00;
  margin-left: 10px;
}
.editPhone .el-input {
  width: 250px;
}
</style>
